<!-- 滚轮横向滚动组件 -->
<template>
  <div class="horwheel-img">
    <div id="shuji">
      <!-- 天空云层部分 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="1261" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4_c.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="2700" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4_c.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="6000" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5.png" class="absolute cloud-ani" alt="static" data-wd="691" data-left="10998" data-top="38" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png" class="absolute cloud-ani" alt="static" data-wd="885" data-left="12850" data-top="27" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="16100" data-top="-20" />
      <!-- 底图部分 -->
      <img id="shuji-long-img" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/bg.jpg" />
      <!-- 前言 -->
      <div data-alt="speed" class="absolute left-0" data-wd="709" data-left="170" data-top="165">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/title.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="519" data-left="1150" data-top="126">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk13.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0 opacity-0" data-wd="180" data-left="1100" data-top="100" data-active="ani3" data-left-percentage="0.6" id="shuji-talk1">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/flp.gif" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="786" data-left="1644">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/person2.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="302" data-left="1280" data-top="571" @click="showModal('shuji')">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/play-mp4_1.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="632" data-left="2583" data-top="278">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/talk1_1.png" class="width-100 opacity-0" />
      </div>

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/3/q1.gif" class="absolute" alt="static" data-wd="750" data-left="3090" data-top="20" id="shuji-gongdi" data-left-percentage="0.6" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk2.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.7" data-wd="467" data-left="3982" data-top="79" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/person4_1.png" class="absolute" alt="static" data-wd="643" data-left="5801" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/3/q2.gif" class="question2" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk3.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.8" data-wd="577" data-left="5301" data-top="562" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk4.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.8" data-wd="520" data-left="6472" data-top="543" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/5/talk11.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.8" id="shuji-msg-1" data-wd="503" data-left="7229" data-top="360" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/A4.png" class="A4-btn" @click="showA4Talk" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/A4-talk.png" id="A4-talk" class="img-static-bg opacity-0" alt="static" data-wd="477" data-left="7964" data-top="137" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk12.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.8" data-wd="573" data-left="10480" data-top="78" id="shuji-msg-2" />

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="600" data-left="11844" data-top="161">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/5/talk6.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="1200" data-left="12631" data-top="271">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/vote-bg.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="306" data-left="12952" data-top="492" @click="handleShowResult">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/vote1.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="305" data-left="13304" data-top="492" @click="handleShowResult">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/vote2.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="100" data-left="13500" data-top="411" @click="handleShowResult">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/hand3.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 opacity-0 " :class="{ 'ani-opacity2': showResult }" data-wd="803" data-left="12865" data-top="71">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/vote-result.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="685" data-left="12300" :class="{ 'z-index--1': showResult }">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/after-vote.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0 " data-wd="769" data-left="12300">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/before-vote2.png" class="width-100 opacity-0" id="after-vote" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="599" data-left="12951" data-top="746">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/talk5.png" class="width-100 opacity-0" />
      </div>

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/record.png" class="img-static-bg" alt="static" data-active="ani1" data-left-percentage="0.8" data-wd="917" data-left="14676" data-top="0" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/q1.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="290" data-left="16973" data-top="835" @click="changeAnswer1()" :class="{ ani1: question }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/q2.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="389" data-left="17351" data-top="835" @click="changeAnswer2()" :class="{ ani1: question }" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/c.png" class="absolute cursor-pointer" alt="static" data-wd="328" data-left="17175" data-top="875" @click="question = true" :style="{ 'z-index': question ? '-1' : '0' }" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/3/a1.png" class="absolute opacity-0" alt="static" data-wd="515" data-left="16627" data-top="168" :class="{ ani1: answer1, 'z-index--1': !answer1 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/a2.png" class="absolute opacity-0" alt="static" data-wd="515" data-left="16624" data-top="168" :class="{ ani1: answer2, 'z-index--1': !answer2 }" />

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="548" data-left="18334" data-top="150" @click="showShujiNver">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/nver.png" class="width-100" />
      </div>
    </div>
    <img v-if="showMouseTip" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mouse.png" class="mouse-tip ani-opacity" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 横向滚动视差滚动对象
let parallax = {
  segment: 15,
  screenWidth: 0,
  dom: null,
  speed: 0.5,
  scrollLeft: 0,
  scrollLeftWithScreen: 0,
  scrollMaxLeft: 0,
  wheelStep: 0,
  minStep: 0,
  curStep: 0,
  longImgWidth: 0,
  longImgRealWidth: 18692,
  longImgRealHeight: 1080,
  imgScale: 1,
  layers: [],
  staticDoms: [],
  music: [],
  extraDom: []
}
let timer
let doingNextMove = false
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showMouseTip: true,
      showResult: false,
      question: false,
      answer1: false,
      answer2: false,
      end: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showShujiNver() {
      this.$emit('showNvModal')
    },
    showA4Talk() {
      const a4Talk = document.getElementById('A4-talk')
      a4Talk.classList.add('ani1')
    },
    reset() {
      if (this.showMouseTip) return
      this.end = false
      this.question = false
      this.showResult = false
      this.answer1 = false
      this.answer2 = false
      this.showMouseTip = true
      const a4Talk = document.getElementById('A4-talk')
      if (a4Talk.classList.contains('ani1')) {
        a4Talk.classList.remove('ani1')
      }
      const afterVote = document.getElementById('after-vote')
      if (afterVote.classList.contains('ani3')) {
        afterVote.classList.remove('ani3')
      }
      parallax.layers = []
      parallax.staticDoms = []
      parallax.music = []
      parallax.extraDom = []
      parallax.dom.style.transform = `translate3d(0, 0, 0)`
      parallax.scrollLeft = 0
      parallax.curStep = 0
      this.init()
    },
    changeAnswer1() {
      this.answer1 = true
      this.answer2 = false
    },
    changeAnswer2() {
      this.answer1 = false
      this.answer2 = true
    },
    handleShowResult() {
      if (this.showResult) return
      this.showResult = true
      const dom = document.getElementById('after-vote')
      dom.classList.add('ani3')
    },
    init() {
      this.aniInit()
      this.wheelInit()
    },
    showMp3(mode) {
      let bgImg = ''
      let width = 0
      let height = 0
      let closeRight = 0
      let closTop = 0
      if (mode === 'field-ganyan') {
        bgImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/chen-mp3-1.png'
        width = 501
        height = 675
        closeRight = 30
        closTop = 120
      }
      this.$emit('openMp3Modal', { mode, bgImg, width, height, closeRight, closTop })
    },
    showModal(mode) {
      let backgroundColor = ''
      let titleImg = ''
      let videoUrl = ''
      if (mode === 'shuji') {
        backgroundColor = '#f4bc45'
        titleImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png'
        videoUrl = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/shuji/shuji.mp4'
      }
      this.$emit('openModal', { mode, backgroundColor, titleImg, videoUrl })
    },
    aniInit() {},
    wheelInit() {
      // 获取监听滚轮事件
      parallax.dom = document.getElementById('shuji')
      // 获取主要滚动dom
      const image = document.getElementById('shuji-long-img')
      // console.log('image.width：', image.width)
      parallax.longImgWidth = image.width
      parallax.dom.style.width = image.width + 'px'
      parallax.imgScale = image.width / parallax.longImgRealWidth
      // 获取屏幕宽度
      parallax.screenWidth = window.innerWidth || (document.body && document.body.clientWidth)
      // 最大滚动到左侧距离
      parallax.scrollMaxLeft = parallax.longImgWidth - parallax.screenWidth
      // 每一次距离(屏幕宽度 / 15 * 速率)
      parallax.wheelStep = (parallax.screenWidth / parallax.segment) * parallax.speed
      // 滚动最小距离
      parallax.minStep = parallax.screenWidth / 1000 / parallax.segment
      // 获取滚动到长图的距离 首次进入就是宽度
      parallax.scrollLeftWithScreen = parallax.screenWidth
      // 获取所有要滚动的图片
      this.initChildren()
      console.log('shuji-parallax:', parallax)
      // 添加滚轮监听事件
      parallax.dom.addEventListener('wheel', this.handleWheel)
    },
    initPosition(element) {
      const realWidth = element.getAttribute('data-wd')
      const realLeft = element.getAttribute('data-left')
      const realTop = element.getAttribute('data-top')
      if (element.hasAttribute('data-wd')) {
        element.style.width = (realWidth / parallax.longImgRealWidth) * 100 + '%'
      }
      element.style.left = (realLeft / parallax.longImgRealWidth) * 100 + '%'
      if (element.hasAttribute('data-top')) {
        element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
      } else {
        element.style.bottom = 0
      }
    },
    initChildren() {
      // 配置图片
      for (let i = 0; i < parallax.dom.children.length; i++) {
        const element = parallax.dom.children[i]
        if (element.getAttribute('data-alt') === 'speed') {
          // 处理动态
          const speed = element.getAttribute('speed') || 1.1
          const realWidth = element.getAttribute('data-wd')
          const realLeft = element.getAttribute('data-left')
          const realTop = element.getAttribute('data-top')
          let left = realLeft * parallax.imgScale
          left += left / 15
          const layer = {
            dom: element,
            realWidth,
            realLeft,
            speed: Number(speed),
            width: realWidth * parallax.imgScale,
            left: left,
            initLeft: left
          }
          parallax.layers.push(layer)
          // 处理div节点样式
          element.style.width = layer.width + 'px'
          if (element.hasAttribute('data-top')) {
            element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
          } else {
            element.style.bottom = 0
          }
          element.style.transform = `translate3d(${layer.left}px, 0, 0)`
          // 处理内层动画节点样式
          const imgDom = element.children[0]
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          const leftPercentage = element.getAttribute('data-left-percentage') || 0.7
          if (imgDom.classList.contains(activeClass)) {
            imgDom.classList.remove(activeClass)
          }
          parallax.staticDoms.push({
            dom: imgDom,
            activeClass,
            leftPercentage,
            active: false
          })
        } else if (element.alt === 'static') {
          // 处理静态
          this.initPosition(element)
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (element.classList.contains(activeClass)) {
            element.classList.remove(activeClass)
          }
          parallax.staticDoms.push({
            dom: element,
            activeClass,
            leftPercentage: element.getAttribute('data-left-percentage') || 0.7,
            active: false
          })
        } else if (element.getAttribute('data-alt') === 'position') {
          this.initPosition(element)
        }
      }
      // 初始化音乐
      const musicContainer = document.getElementById('shuji-music-contianer')
      const audioElements = musicContainer.getElementsByTagName('audio')
      for (var i = 0; i < audioElements.length; i++) {
        const element = audioElements[i]
        const imgDom = document.getElementById(element.getAttribute('data-img'))
        const activeClass = imgDom.getAttribute('data-active')
        if (imgDom.classList.contains(activeClass)) {
          imgDom.classList.remove(activeClass)
        }
        parallax.music.push({
          dom: element,
          played: false,
          ended: false,
          imgDom: imgDom,
          endPlayLeft: element.getAttribute('data-end-left') * parallax.imgScale,
          leftPercentage: imgDom.getAttribute('data-left-percentage'),
          activeClass
        })
      }
    },
    listenerAnimation() {
      // 获取所有静态dom
      const { screenWidth } = parallax
      for (let i = 0; i < parallax.staticDoms.length; i++) {
        const item = parallax.staticDoms[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          element.classList.add(item.activeClass)
          item.active = true
        }
      }
      // 获取所有音乐dom
      for (let i = 0; i < parallax.music.length; i++) {
        const item = parallax.music[i]
        const imgDom = item.imgDom
        // 已经结束的就跳过
        if (item.ended) continue
        // 正在播放的需要判断结束位置
        if (item.played) {
          //判断停止位置是否到达
          if (parallax.scrollLeftWithScreen >= item.endPlayLeft) {
            this.$emit('playAudio', item.dom)
            item.ended = true
          }
          continue
        }
        if (imgDom.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          this.$emit('playAudio', item.dom)
          item.played = true
          if (item.activeClass) {
            imgDom.classList.add(item.activeClass)
          }
        }
      }
      // 获取所有特殊的dom
      for (let i = 0; i < parallax.extraDom.length; i++) {
        const item = parallax.extraDom[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          item.active = true
          item.beginAni && item.beginAni()
        }
      }
    },
    handleWheel(event) {
      if (this.showMouseTip) {
        this.showMouseTip = false
      }
      event.preventDefault()
      // 监听动画效果
      this.listenerAnimation()
      // 判断是否前进后退
      const isForward = event.wheelDeltaY < 0
      // 根据滚动距离修改当前位置
      parallax.curStep = parallax.curStep + (isForward ? 1 : -1) * parallax.wheelStep
      // 限制移动范围，防止移动超出图片边界
      parallax.curStep = Math.max(0, Math.min(parallax.curStep, parallax.scrollMaxLeft))
      if (!this.end && parallax.curStep === parallax.scrollMaxLeft) {
        this.end = true
        this.$emit('end')
      }
      // console.log(parallax.curStep)
      doingNextMove = true
      timer || (timer = setInterval(() => this.changeScrollLeft(), 17))
    },
    changeScrollLeft() {
      const step = (parallax.curStep - parallax.scrollLeft) / parallax.segment
      // 如果滚动步长的绝对值大于设定的最小步长。
      if (Math.abs(step) > parallax.minStep) {
        parallax.scrollLeft += step
        parallax.scrollLeftWithScreen += step
        parallax.dom.style.transform = `translate3d(${-parallax.scrollLeft}px, 0, 0)`
        // 调整layers
        for (let i = 0; i < parallax.layers.length; i++) {
          const layer = parallax.layers[i]
          if (layer.speed > 0 && layer.speed < 1) {
            layer.left = layer.initLeft + parallax.scrollLeft * (1 - layer.speed)
          } else {
            layer.left = layer.initLeft - parallax.scrollLeft * (layer.speed - 1)
          }
          layer.dom.style.transform = `translate3d(${layer.left}px, 0, 0)`
        }
      } else if (doingNextMove) {
        console.log('doingNextMove')
        // 如果当前滚动步长小于等于最小步长，并且标志表明有下一个移动要进行。
        doingNextMove = false
        clearInterval(timer)
        timer = null
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log('created');
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.wheelInit();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (timer) {
      clearInterval(timer)
    }
    parallax.dom.removeEventListener('wheel', this.handleWheel)
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.horwheel-img {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  #shuji {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #76c5ff;
  }
  #shuji-long-img {
    height: 100%;
  }
  .sky {
    position: absolute;
    width: 70.54%;
    left: 0;
    top: 0;
    z-index: -1;
  }

  .mouse-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7%;
    transform: translate(-50%, -50%);
  }

  .img-speed-bg {
    position: absolute;
    left: 0;
  }
  .img-static-bg {
    position: absolute;
    opacity: 0;
  }

  .question1 {
    position: absolute;
    width: 3.7732%;
    left: 18.3351%;
    top: 1.2037%;
    // animation: shakeAnimation 1s ease-in-out infinite;
  }
  .question2 {
    position: absolute;
    width: 6.58247%;
    left: 28.7041%;
    top: 1%;
    // animation: shakeAnimation 1s ease-in-out infinite;
  }
  @keyframes shakeAnimation {
    0% {
      transform: translateX(0) translateY(0);
    }
    25% {
      transform: translateX(-5px) translateY(-4px);
    }
    50% {
      transform: translateX(5px) translateY(4px);
    }
    75% {
      transform: translateX(-3px) translateY(-2px);
    }
    100% {
      transform: translateX(3px) translateY(2px);
    }
  }

  .A4-btn {
    position: absolute;
    width: 2.22165%;
    left: 44.113%;
    top: 70.3704%;
    cursor: pointer;
  }

  .answer1 {
    position: absolute;
    width: 3.2732%;
    left: 93.366%;
    top: 3.51852%;
  }

  .cloud1 {
    position: absolute;
    width: 6.95%;
    top: 0;
    left: 2%;
  }
  .cloud1-ani {
    animation: ani-cloud 130s infinite;
    animation-delay: 3s;
  }

  .cloud2 {
    position: absolute;
    width: 10.26%;
    left: 2%;
    top: 0;
  }
  .cloud2-ani {
    animation: ani-cloud 120s infinite;
  }

  .cloud5 {
    position: absolute;
    width: 10.26%;
    left: 2%;
    top: 32.12%;
  }
  .cloud5-ani {
    animation: ani-cloud 140s infinite;
    animation-delay: 8s;
  }

  @keyframes ani-cloud {
    0% {
      left: 2%;
    }
    100% {
      left: 61.77%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShuJi/index.vue